import React from 'react';
import { useTranslation } from 'react-i18next';
import DownloadRounded from '@mui/icons-material/DownloadRounded';
import SaveRounded from '@mui/icons-material/SaveRounded';
import { Stack } from '@mui/material';

import { useWorkspaceContext } from 'src/components/workspace/WorkspaceContext';

import ClearDatalines from './components/ClearDatalines';
import ConfigureReport from './components/ConfigureReport';

export const WORKSPACE_ACTION_BANNER_TEST_ID = 'workspace-action-banner';

const WorkspaceActionBanner = () => {
  const { t } = useTranslation('workspace');
  const { orderReport, saveDraft } = useWorkspaceContext();

  return (
    <Stack
      direction="row"
      data-test-id={WORKSPACE_ACTION_BANNER_TEST_ID}
      sx={{
        height: '6rem',
      }}
    >
      <ClearDatalines />
      <ConfigureReport
        afterSubmit={saveDraft}
        buttonAndHeadlineText={t('saveDefinition.button')}
        buttonIcon={<SaveRounded fontSize="large" />}
        headerIcon={<SaveRounded fontSize="large" />}
        reportNameOnly
      />
      <ConfigureReport
        afterSubmit={orderReport}
        buttonAndHeadlineText={t('orderReport.button')}
        buttonIcon={<DownloadRounded fontSize="large" />}
        headerIcon={<DownloadRounded fontSize="large" />}
      />
    </Stack>
  );
};

export default WorkspaceActionBanner;
